import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import appLogo from '../../assets/app-logo.png';
import GetAppModal from '../GetAppModal/GetAppModal';
import { WEB_APP_URL } from '../../utils/webApp';
import './Navbar.css';

const APP_STORE_URL = 'https://apps.apple.com/pt/app/voia-travel/id6747190886?l=en-GB';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.voia.travel.mobile';

const Navbar = ({ variant = 'default' }) => {
  const location = useLocation();
  const path = location.pathname;
  const [getAppOpen, setGetAppOpen] = useState(false);

  const isActive = (route) => {
    if (route === '/visited-countries-map') return path.startsWith('/visited-countries-map');
    if (route === '/blog') return path.startsWith('/blog');
    return false;
  };

  return (
    <header className={`navbar${variant === 'transparent' ? ' navbar--transparent' : ''}${variant === 'blue' ? ' navbar--blue' : ''}`}>
      <Link to="/">
        <img src={appLogo} alt="VOIA Logo" className="navbarLogo" loading="eager" />
      </Link>
      <nav className="navbarNav">
        <Link
          to="/visited-countries-map"
          className={`navbarLink ${isActive('/visited-countries-map') ? 'navbarLinkActive' : ''}`}
        >
          My Map
        </Link>
        <Link
          to="/blog"
          className={`navbarLink ${isActive('/blog') ? 'navbarLinkActive' : ''}`}
        >
          Blog
        </Link>
        <a href={WEB_APP_URL} className="navbarLink onlyDesktop">
          Log in
        </a>
        <button type="button" className="navbarGetApp onlyDesktop" onClick={() => setGetAppOpen(true)}>
          Get the app
        </button>
        <div className="navbarStores onlyTouch">
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="navbarStoreLink"
          >
            <img src="/assets/app_store_badge.svg" alt="Download VOIA on the App Store" />
          </a>
          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="navbarStoreLink"
          >
            <img src="/assets/google_play_badge.png" alt="Get VOIA on Google Play" />
          </a>
        </div>
      </nav>
      <GetAppModal open={getAppOpen} onClose={() => setGetAppOpen(false)} />
    </header>
  );
};

export default Navbar;
